module.exports = __webpack_public_path__ + "img/facebook.b954cc47.svg";